<form id="register-form" [formGroup]="formGroup" (ngSubmit)="updateUser($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.userData?.fullName }}</span>
    <button class="icon-button icon-close" (click)="goToUser(item)"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">{{ "users.main.information" | translate }}</div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="fullName" [label]="'users.item.user' | translate" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="id" [label]="'users.item.gid' | translate" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="eMail" [label]="'users.item.email' | translate" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="department" [label]="'users.item.department' | translate" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="departmentText" [label]="'users.item.departmentText' | translate" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-select formControlName="userRole" [label]="'users.item.roleTitle' | translate">
                @for (option of roleTypes; track option) {
                  <sag-ui-option [value]="option">
                    {{ "users.item.role." + option | translate }}
                  </sag-ui-option>
                }
              </sag-ui-select>
            </div>
            <div class="flex-1 card-cell"></div>
          </div>
        </div>
      </div>
      <!--			<div class="information-container">
							<div class="statistics-title statistics-title&#45;&#45;full">{{'users.main.certificate' | translate}}</div>
							<div class="information-content">
								<div class="flex-row">
									<div class="flex-1 card-cell">
										<span class="information-text">
											{{'users.main.certificateInformation' | translate}}
											<ng-container *ngIf="item.certificateExpiration">
												{{'users.main.certificateExpiration' | translate: {date: (item.certificateExpiration | date: 'MMM d y h:mm')} }}
											</ng-container>
										</span>
									</div>
								</div>
								<div *ngIf="hasCertificate" class="flex-row">
									<div class="flex-1 card-cell">
										<button type="button" (click)="deleteExistingCertificate()" class="primary inverse">
											{{'users.main.deleteCertificate' | translate}}
										</button>
									</div>
								</div>
								<div *ngIf="!hasCertificate" class="flex-row">
									<dapsr-drop-zone
											class="flex-2 card-cell"
											formControlName="certificate"
											acceptType="application/x-x509-ca-cert">
									</dapsr-drop-zone>
									<div class="flex-1"></div>
								</div>
							</div>
						</div>-->
    </div>
  </div>
</form>
